import { Component, Vue } from 'vue-property-decorator'

@Component
export default class VhFixMixin extends Vue {
    mounted() {
        window.addEventListener('resize', this.updateViewHeight)
        this.updateViewHeight()
    }

    destroyed() {
        window.removeEventListener('resize', this.updateViewHeight)
    }

    updateViewHeight(): void {
        const vh = window.innerHeight * 0.01
        if (vh) {
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        } else {
            // Not all browsers trigger a resize once the innerHeight is known, so we force our own
            setTimeout(this.updateViewHeight, 250)
        }
    }
}
